module.exports = __webpack_public_path__ + "img/randomizer-details3.1b78d557.png";